<template>
  <b-container fluid>
    <b-row>
      <b-col xl="12" lg="12" sm="12">
            <iq-card>
                <template v-slot:body>
                    <b-row>
                        <b-col xl="12" lg="12" sm="12">
                                <b-table-simple striped bordered small hover>
                                <tbody>
                                    <b-tr>
                                        <b-td>{{$t('child_admission_management.registration_id')}}</b-td>
                                        <b-td> {{ assign.registration_id }}</b-td>
                                    </b-tr>
                                    <b-tr>
                                        <b-td>{{$t('institute_manangement.organization_name')}}</b-td>
                                        <b-td>{{ getOrgName(assign.org_id) }}</b-td>
                                    </b-tr>
                                     <b-tr>
                                        <b-td>{{$t('institute_manangement.institute_type')}}</b-td>
                                        <b-td>{{ getInstituteType(assign.office_type_id) }}</b-td>
                                    </b-tr>
                                    <b-tr>
                                        <b-td>{{$t('institute_manangement.institute_name')}}</b-td>
                                        <b-td>{{ (currentLocale === 'en') ? assign.institute_name : assign.institute_name_bn }}</b-td>
                                    </b-tr>
                                    <b-tr>
                                        <b-td>{{$t('child_admission_management.student_type')}}</b-td>
                                        <b-td>{{ getStudentType(assign.student_type) }}</b-td>
                                    </b-tr>
                                    <b-tr>
                                        <b-td>{{$t('child_admission_management.name')}}</b-td>
                                        <b-td>{{ (currentLocale === 'en') ? assign.name : assign.name_bn }}</b-td>
                                    </b-tr>
                                     <b-tr>
                                        <b-td>{{$t('child_admission_management.address')}}</b-td>
                                        <b-td>{{ (currentLocale === 'en') ? assign.address : assign.address_bn }}</b-td>
                                    </b-tr>
                                    <b-tr>
                                        <b-td>{{$t('child_admission_management.legal_guardian')}}</b-td>
                                        <b-td>{{ (currentLocale === 'en') ? assign.legal_guardian : assign.legal_guardian_bn }}</b-td>
                                    </b-tr>
                                    <b-tr>
                                        <b-td>{{$t('child_admission_management.contact_no')}}</b-td>
                                        <b-td>{{ assign.contact_no | mobileNumber }}</b-td>
                                    </b-tr>
                                     <b-tr>
                                        <b-td>{{$t('child_admission_management.date')}}</b-td>
                                        <b-td>{{ assign.date | dateFormat }}</b-td>
                                    </b-tr>
                                    <b-tr>
                                        <b-td :colspan="2">{{$t('child_admission_management.reason')}} : {{ (currentLocale === 'en') ? assign.reason : assign.reason_bn }}</b-td>
                                    </b-tr>
                                 </tbody>
                                </b-table-simple>
                                <div class="row">
                                    <div class="col-sm-3"></div>
                                    <div class="col text-right">
                                        <b-button variant="danger" class="mr-1" @click="$bvModal.hide('modal-detail')">{{ $t('globalTrans.close') }}</b-button>
                                    </div>
                                </div>
                        </b-col>
                    </b-row>
                </template>
            </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { mapGetters } from 'vuex'
import { core } from '../../../../../config/pluginInit'
// import { childServiceBaseUrl } from '@/config/api_config'
// import ExportPdf from './export-pdf_details'

export default {
    props: ['id'],
    components: {
    },
    created () {
        if (this.id) {
            const tmp = this.getManagementInfoData()
            this.assign = tmp
        }
    },
    mounted () {
        core.index()
    },
    data () {
        return {
            assign: {
            }
        }
    },
    computed: {
        orgList: function () {
            return this.$store.state.commonObj.organizationProfileList.filter(item => item.status === 0)
        },
        currentLocale () {
            return this.$i18n.locale
        },
        ...mapGetters({
            childCommonObj: 'ChildService/commonObj'
        })
    },
    methods: {
        getManagementInfoData () {
            const tmpData = this.$store.state.list.find(item => item.id === this.id)
            return JSON.parse(JSON.stringify(tmpData))
        },
       getOrgName (orgId) {
        const tmpData = this.$store.state.commonObj.organizationProfileList.find(item => item.value === orgId && item.status === 0)
        if (this.$i18n.locale === 'bn') {
            return tmpData.text_bn
        } else {
            return tmpData.text_en
        }
         },
        getInstituteType (Id) {
        const tmpData = this.$store.state.commonObj.officeTypeList.find(item => item.value === Id && item.status === 0)
        if (this.$i18n.locale === 'bn') {
            return tmpData.text_bn
        } else {
            return tmpData.text_en
        }
        },
         getStudentType (typeId) {
        const Type = this.$store.state.ChildService.commonObj.studentTypeList.find(type => type.value === typeId)
        if (this.$i18n.locale === 'bn') {
            return Type.text_bn
        } else {
            return Type.text_en
        }
        },
         getClassName (id) {
            const className = this.$store.state.ChildService.commonObj.classList.find(item => item.value === id)
            if (this.$i18n.locale === 'bn') {
                return className.text_bn
            } else {
                return className.text_en
            }
        },
         getSchoolName (id) {
            const SchoolName = this.$store.state.ChildService.commonObj.schoolList.find(item => item.value === id)
            if (this.$i18n.locale === 'bn') {
                return SchoolName.text_bn
            } else {
                return SchoolName.text_en
            }
        },
        getInstituteName (InstId) {
            const institute = this.childCommonObj.instituteList.find(institute => institute.value === InstId)
            if (this.$i18n.locale === 'bn') {
                return institute.text_bn
            } else {
               return institute.text_en
            }
        }
    //  pdfExport () {
    //   const reportTitle = this.$t('child_admission_management.assign_to_school')
    //   ExportPdf.exportPdfDetails(childServiceBaseUrl, 'configuration/report-heading/detail', 3, reportTitle, this.assign, this)
    // }
    }
}

</script>
